import { useState } from 'react'

interface Props {
  onClick: (value: boolean) => void
}

export default function CheckToggle({ onClick }: Props) {
  const [active, setActive] = useState(false)
  function handleClick() {
    setActive(!active)
    onClick(!active)
  }
  return <i onClick={handleClick} className={`icon-check ${active ? 'active' : 'inactive'}`}></i>
}
